<template>
  <div class="training-root">
    <div class="max-w-7xl mx-auto mb-10">
      <HeroPictureForm v-bind="heroData" class="px-4" />
      <div class="flex justify-center flex-wrap text-center">
        <div
          v-for="(feature, index) in trainingFeatures"
          :key="`feature-${index}`"
          class="max-w-xs p-8"
        >
          <img :src="feature.image" alt="block-image" class="mx-auto mb-4" />
          <TypeHeading
            :variant="$options.Typography.Heading.TITLE"
            :weight="$options.Typography.Weights.STRONG"
            tag="p"
            class="mb-4"
          >
            {{ feature.title }}
          </TypeHeading>
          <TypeBody
            :variant="$options.Typography.Body.MEDIUM"
            :weight="$options.Typography.Weights.REGULAR"
            tag="p"
          >
            {{ feature.description }}
          </TypeBody>
        </div>
      </div>
    </div>
    <Ribbon />
    <FormattedHeader
      header="It's 2020, Every Small Business Needs Training"
      class="max-w-4xl mx-auto mt-20 px-4"
    />

    <div
      class="max-w-7xl mx-auto flex flex-wrap items-center justify-center py-10 mb-8"
    >
      <CarouselNavigation
        :nav-items="navItems"
        :current="current"
        @set-nav="setNav"
      />
      <Stage
        :items="items"
        :current="current"
        class="flex-shrink-0"
        @next="setNav('next')"
      />
    </div>

    <Ribbon variant="primary" />

    <div class="max-w-7xl mx-auto py-10 px-4">
      <InfoBlock
        v-for="(info, index) in trainingInfoBlocks"
        :key="`training-info-${index}`"
        v-bind="info"
        :reverse="index % 2 ? false : true"
      >
      </InfoBlock>
    </div>

    <Ribbon variant="gray" class="mb-20" />

    <RegistrationPrompt
      button-id="company-size-button"
      class="mx-auto shadow-lg mb-10"
    />

    <Ribbon variant="gray" />
  </div>
</template>

<script>
import { defineComponent, ref, useMeta } from '@nuxtjs/composition-api';
import { TypeHeading, TypeBody, constants } from '@bambeehr/pollen';
import { trainingFeatures, trainingInfoBlocks } from '../mocks/index';
import HeroPictureForm from '../../../../components/HeroPictureForm.vue';
import FormattedHeader from '@/components/FormattedHeader.vue';
import Ribbon from '@/components/Ribbon.vue';
import CarouselNavigation from '@/modules/InformationPages/Training/components/Carousel/CarouselNavigation.vue';
import Stage from '@/modules/InformationPages/Training/components/Carousel/Stage.vue';
import InfoBlock from '@/components/InfoBlock.vue';
import {
  carouselNavLabels,
  trainingCarouselItems,
} from '@/modules/InformationPages/Training/mocks/index';
import RegistrationPrompt from '@/components/RegistrationPrompt.vue';
import useGlobalSettings from '@/hooks/useGlobalSettings';
const { Typography } = constants;

export default defineComponent({
  name: 'TrainingRoot',
  Typography,
  components: {
    CarouselNavigation,
    FormattedHeader,
    HeroPictureForm,
    Ribbon,
    InfoBlock,
    TypeHeading,
    TypeBody,
    Stage,
    RegistrationPrompt,
  },
  setup() {
    const current = ref(0);
    const heroData = {
      title: 'Fortune 500 Training For Everyone',
      subtitle: 'Sexual Harassment, OSHA, & More For All 50 States',
      heroImage: '../assets/information/training/training-hero.png',
    };

    const setNav = (value) => {
      if (value === 'next') {
        if (current.value < trainingCarouselItems.length - 1) {
          current.value = current.value + 1;
        } else {
          current.value = 0;
        }
      } else {
        current.value = value;
      }
    };

    const { setHeader } = useGlobalSettings();

    setHeader({
      header: null,
      subheader: null,
      heroImage: null,
      metaTitle: null,
      registration: false,
      noHero: true,
      topNavToggle: true,
    });

    useMeta(() => ({ title: heroData.title }));

    return {
      heroData,
      trainingFeatures,
      navItems: carouselNavLabels,
      items: trainingCarouselItems,
      current,
      setNav,
      trainingInfoBlocks,
    };
  },
  head() {},
});
</script>
